/* Přihlášení k odběru push notifikací.
 *
 * O povolení se zásadně neptáme sami od sebe při načtení stránky — lidé to
 * plošně odmítají a odmítnutí jde v prohlížeči vzít zpět jen složitě. Ptáme
 * se až po kliknutí na tlačítko, tedy po vědomém rozhodnutí.
 */

function base64ToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

function csrf() {
  const el = document.querySelector("[name=csrfmiddlewaretoken]");
  return el ? el.value : "";
}

async function posli(url, payload) {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-CSRFToken": csrf() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`${url} → ${res.status}`);
  return res.json();
}

function nastavStav(btn, stav) {
  const texty = {
    prihlasen: "Notifikace zapnuté",
    neprihlasen: "Hlídat závody",
    pracuje: "Moment…",
  };
  btn.textContent = texty[stav];
  btn.dataset.stav = stav;
  btn.disabled = stav === "pracuje";
}

export async function initNotifikace() {
  // Tlačítek může být na stránce víc — pruh na homepage i hero výsledkovky.
  const tlacitka = [...document.querySelectorAll("[data-push-toggle]")];
  if (!tlacitka.length) return;

  const podporovano =
    "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

  // iOS umí push jen u aplikace přidané na plochu. V Safari na webu tlačítko
  // nemá co nabídnout, tak místo něj ukážeme, co je potřeba udělat.
  const jeIos =
    /iphone|ipad|ipod/i.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const jeNaPlose =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  // Prohlížeč push neumí vůbec — nabídku nemá smysl ukazovat.
  if (!podporovano) {
    for (const btn of tlacitka) {
      const box = btn.closest(".push-cta");
      if (box) box.hidden = true;
    }
    return;
  }

  // iOS umí push jen z webu přidaného na plochu. Mrtvé tlačítko vypadá jako
  // porucha, tak ho schováme a místo něj ukážeme, co je potřeba udělat.
  if (jeIos && !jeNaPlose) {
    for (const btn of tlacitka) {
      btn.hidden = true;
      const napoveda = btn.parentElement.querySelector("[data-push-hint]");
      if (napoveda) {
        napoveda.hidden = false;
        napoveda.classList.add("push-cta__hint--hlavni");
      }
    }
    return;
  }

  const reg = await navigator.serviceWorker.ready;
  const existujici = await reg.pushManager.getSubscription();
  const vsem = (stav) => tlacitka.forEach((b) => nastavStav(b, stav));
  vsem(existujici ? "prihlasen" : "neprihlasen");

  for (const btn of tlacitka) btn.addEventListener("click", async () => {
    const puvodni = btn.dataset.stav;
    vsem("pracuje");
    try {
      if (puvodni === "prihlasen") {
        const sub = await reg.pushManager.getSubscription();
        if (sub) {
          await posli("/push/odhlasit/", { endpoint: sub.endpoint });
          await sub.unsubscribe();
        }
        vsem("neprihlasen");
        return;
      }

      const povoleni = await Notification.requestPermission();
      if (povoleni !== "granted") {
        vsem("neprihlasen");
        return;
      }

      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: base64ToUint8Array(btn.dataset.pushKey),
      });
      const json = sub.toJSON();
      await posli("/push/prihlasit/", {
        endpoint: json.endpoint,
        keys: json.keys,
      });
      vsem("prihlasen");
    } catch (err) {
      console.error("Notifikace se nepodařilo nastavit:", err);
      vsem(puvodni);
    }
  });
}
